import Cookies from 'js-cookie';

export default class {
  constructor() {
    this.$forms = $('.wpcf7 form');
  }

  setAnalyticsData() {
    const gid = Cookies.get('gclid');
    if (!gid) {
      return;
    }
    setTimeout(() => {
      this.$forms.find('input#zc_gad').val(gid);
    }, 1500);
  }

  init() {
    $(() => {
      this.$forms.on('submit', (event) => {
        const button = $(event.target).find('[type=submit]');
        button.attr('disabled', true);
        button.addClass('loader');
      });

      this.$forms.on('wpcf7submit', (event) => {
        this.$forms.find('.form-group').removeClass('error');
        const button = $(event.target).find('[type=submit]');
        button.attr('disabled', false);
        button.removeClass('loader');
        this.$forms.find('.wpcf7-not-valid').closest('.form-group').addClass('error');
      });


      this.$forms.find('select').on('change', (event) => {
        const { value } = event.target.options[event.target.options.selectedIndex];
        event.target.classList.toggle('filled', value.length);
      });

      $('.form-group input, .form-group textarea, .form-group select').on('blur focus', (e) => {
        const $inputGroup = $(e.currentTarget).closest('.form-group');

        $inputGroup.toggleClass('focus');

        if (e.currentTarget.value && $inputGroup.hasClass('active')) {
          return;
        }

        $inputGroup.toggleClass('active');
      });

      this.setAnalyticsData()
    });
  }
}
